import {inject, injectable} from "inversify";
import {Player, Team} from "@/modules/team/entity";
import {TransferLog} from "@/modules/transfer-market/entity";
import {Season} from "@/modules/season/entity";
import LineupHandler from "@/modules/team/services/LineupHandler";
import {EventEmitter} from "@/modules/base/events";
import {BeforeTransferEvent} from "@/modules/transfer-market/events/BeforeTransferEvent";
import {AfterTransferEvent} from "@/modules/transfer-market/events/AfterTransferEvent";
import WageCalculator from "@/modules/team/services/WageCalculator";
import chance from "@/modules/base/services/chance";

@injectable()
export default class PlayerTransferrer {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(LineupHandler) private lineupHandler: LineupHandler,
    @inject(WageCalculator) private wageCalculator: WageCalculator,
  ) {}

  public async transfer(player: Player, toTeam: Team, price: number) {
    if (player.transferred) {
      throw 'Player has been transferred this season already.';
    }

    await this.em.emitAsync(new BeforeTransferEvent(player, toTeam, price));

    const season = await Season.current();

    const log = new TransferLog();
    log.season = season;
    log.player = player;
    log.from = player.team;
    log.to = toTeam;
    log.price = price;
    log.transferredAt = season.currentDateRaw;
    await log.save();

    player.team = toTeam;
    player.transferred = true;
    player.wage = this.wageCalculator.calculate(player);
    // todo refactor into service
    player.contractYears = chance.integer({min: 2, max: 5});

    if (toTeam.user) {
      player.revelation = 100;
    }
    // todo add player wage
    await player.save();

    // todo do via events
    await this.lineupHandler.remove(player);

    await this.em.emitAsync(new AfterTransferEvent(player, toTeam, price));
  }
}
